import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    PinterestIcon,
    PinterestShareButton,
    RedditIcon,
    RedditShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from "react-share";
import React, {FC} from 'react';

interface ShareSOcialProps {
    shareUrl: string;
    mediaUrl: string;
    fileName: string;
}

export const ShareSocial: FC<ShareSOcialProps> = (props) => {


    return (
       <div className="flex justify-center items-center">
            <div className='grid grid-cols-5 gap-2 lg:grid-flow-col '>
            <FacebookShareButton url={props.shareUrl} >
                <FacebookIcon/>
            </FacebookShareButton>

            <TwitterShareButton url={props.shareUrl} >
            <TwitterIcon/>
            </TwitterShareButton>

            <LinkedinShareButton url={props.shareUrl} >
            <LinkedinIcon/>
            </LinkedinShareButton>

            <WhatsappShareButton url={props.shareUrl} >
            <WhatsappIcon/>
            </WhatsappShareButton>

            <PinterestShareButton url={props.shareUrl} media={props.mediaUrl} >
            <PinterestIcon/>
            </PinterestShareButton>
            <RedditShareButton url={props.shareUrl} >
            <RedditIcon/>
            </RedditShareButton>
            <TelegramShareButton url={props.shareUrl} >
            <TelegramIcon/>
            </TelegramShareButton>
            <EmailShareButton url={props.shareUrl} >
            <EmailIcon/>
            </EmailShareButton>



       
        </div>
       </div>
    );
}